var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckBoxS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-check-box",
    "data-name": "Icon material-check-box",
    d: "M16.472,2.25H4.028A1.777,1.777,0,0,0,2.25,4.028V16.472A1.777,1.777,0,0,0,4.028,18.25H16.472a1.777,1.777,0,0,0,1.778-1.778V4.028A1.777,1.777,0,0,0,16.472,2.25Zm-8,12.444L4.028,10.25,5.281,9l3.191,3.182,6.747-6.747,1.253,1.262Z",
    transform: "translate(-2.25 -2.25)",
    fill: "#fd8f46"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxS);
export default __webpack_public_path__ + "static/media/check-box-s.9224c52e622868080f99f98bf300f8d3.svg";
export { ForwardRef as ReactComponent };